// Utils
import { allSelectedElementsOnCanvas, commentsFeedbackOtherwiseAll, feedbackRequired } from './toolbarToolConfigUtils';

// Components
import ColorTool from '../../toolbar/selectionTools/colorTools/ColorTool';
import TitleTool from '../../toolbar/selectionTools/titleTool/TitleTool';
import CaptionTool from '../../toolbar/selectionTools/captionTool/CaptionTool';
import ReactionTool from '../../toolbar/selectionTools/reactionTool/ReactionTool';
import IconTool from '../../toolbar/selectionTools/iconTools/IconTool';
import MediaTool from '../../toolbar/selectionTools/attachmentTool/MediaTool';
import MediaLoopTool from '../../toolbar/selectionTools/attachmentTool/MediaLoopTool';
import MediaAutoplayTool from '../../toolbar/selectionTools/attachmentTool/MediaAutoplayTool';
import DisplayModeTool from '../../toolbar/selectionTools/displayModeTool/DisplayModeTool';
import ImageEditTool from '../../toolbar/selectionTools/imageEditTool/ImageEditTool';
import ShowBackgroundTool from '../../toolbar/selectionTools/showBackgroundTool/ShowBackgroundTool';
import CustomColorTool from '../../toolbar/selectionTools/colorTools/CustomColorTool';
import StartArrowTool from '../../toolbar/selectionTools/arrowTools/StartArrowTool';
import EndArrowTool from '../../toolbar/selectionTools/arrowTools/EndArrowTool';
import LineStyleTool from '../../toolbar/selectionTools/lineTools/LineStyleTool';
import LineWeightTool from '../../toolbar/selectionTools/lineTools/LineWeightTool';
import LineLabelTool from '../../toolbar/selectionTools/lineTools/LineLabelTool';
import CollapseTool from '../../toolbar/selectionTools/commentTools/CollapseTool';
import EditDrawingTool from '../../toolbar/selectionTools/editDrawingTool/EditDrawingTool';
import TableOperationsToolList from '../../toolbar/selectionTools/richContentTools/TableOperationsToolList';
import AlignmentTool from '../../toolbar/selectionTools/arrangementTools/alignmentTools/AlignmentTool';
import DistributeTool from '../../toolbar/selectionTools/arrangementTools/distributeTools/DistributeTool';
import ConnectTool from '../../toolbar/selectionTools/connectTool/ConnectTool';

// Constants
import { TOOL_HEIGHT } from './toolbarToolConfigConstants';

// Types
import { ToolbarItemConfig } from '../toolbarTypes';

const COLOR: ToolbarItemConfig = {
    id: 'COLOR',
    name: 'Color',
    component: ColorTool,
    height: TOOL_HEIGHT.SQUARE,
    multiSelect: true,
    permissionPredicate: commentsFeedbackOtherwiseAll,
};

const TITLE: ToolbarItemConfig = {
    id: 'TITLE',
    name: 'Title',
    component: TitleTool,
    height: TOOL_HEIGHT.SQUARE,
    multiSelect: true,
};

const CAPTION: ToolbarItemConfig = {
    id: 'CAPTION',
    name: 'Caption',
    component: CaptionTool,
    height: TOOL_HEIGHT.SQUARE,
    multiSelect: false,
};

const REACTION: ToolbarItemConfig = {
    id: 'REACTION',
    name: 'Add reaction',
    component: ReactionTool,
    height: TOOL_HEIGHT.SQUARE,
    multiSelect: false,
};

const ICON: ToolbarItemConfig = {
    id: 'ICON',
    name: 'Icon',
    component: IconTool,
    height: TOOL_HEIGHT.SQUARE,
    multiSelect: false,
};

const MEDIA: ToolbarItemConfig = {
    id: 'MEDIA',
    name: 'Media',
    component: MediaTool,
    height: TOOL_HEIGHT.SQUARE,
    multiSelect: false,
};

const MEDIA_LOOP: ToolbarItemConfig = {
    id: 'MEDIA_LOOP',
    name: 'Loop',
    component: MediaLoopTool,
    height: TOOL_HEIGHT.SQUARE,
    multiSelect: true,
};

const MEDIA_AUTOPLAY: ToolbarItemConfig = {
    id: 'MEDIA_AUTOPLAY',
    name: 'Autoplay',
    component: MediaAutoplayTool,
    height: TOOL_HEIGHT.SQUARE,
    multiSelect: true,
};

const DISPLAY_MODE: ToolbarItemConfig = {
    id: 'DISPLAY_MODE',
    name: 'Preview',
    component: DisplayModeTool,
    height: TOOL_HEIGHT.SQUARE,
    multiSelect: true,
};

const IMAGE_EDIT: ToolbarItemConfig = {
    id: 'IMAGE_EDIT',
    name: 'Edit image',
    component: ImageEditTool,
    height: TOOL_HEIGHT.SQUARE,
    multiSelect: false,
};

const SHOW_BACKGROUND: ToolbarItemConfig = {
    id: 'SHOW_BACKGROUND',
    name: 'Transparent',
    component: ShowBackgroundTool,
    height: TOOL_HEIGHT.SQUARE,
    multiSelect: true,
};

const CUSTOM_COLOR: ToolbarItemConfig = {
    id: 'CUSTOM_COLOR',
    name: 'Color',
    component: CustomColorTool,
    height: TOOL_HEIGHT.SQUARE,
    multiSelect: true,
};

const COLOR_DISPLAY: ToolbarItemConfig = {
    id: 'COLOR_DISPLAY',
    name: 'Display',
    component: ColorTool,
    height: TOOL_HEIGHT.SQUARE,
    multiSelect: true,
};

const START_ARROW: ToolbarItemConfig = {
    id: 'START_ARROW',
    name: 'Start',
    component: StartArrowTool,
    height: TOOL_HEIGHT.SQUARE,
    multiSelect: true,
};

const END_ARROW: ToolbarItemConfig = {
    id: 'END_ARROW',
    name: 'End',
    component: EndArrowTool,
    height: TOOL_HEIGHT.SQUARE,
    multiSelect: true,
};

const LINE_STYLE: ToolbarItemConfig = {
    id: 'LINE_STYLE',
    name: 'Dashed',
    component: LineStyleTool,
    height: TOOL_HEIGHT.SQUARE,
    multiSelect: true,
};

const LINE_WEIGHT: ToolbarItemConfig = {
    id: 'LINE_WEIGHT',
    name: 'Weight',
    component: LineWeightTool,
    height: TOOL_HEIGHT.SQUARE,
    multiSelect: true,
};

const LINE_LABEL: ToolbarItemConfig = {
    id: 'LINE_LABEL',
    name: 'Label',
    component: LineLabelTool,
    height: TOOL_HEIGHT.SQUARE,
    multiSelect: false,
};

const COLLAPSE: ToolbarItemConfig = {
    id: 'COLLAPSE',
    name: 'Collapse',
    component: CollapseTool,
    height: TOOL_HEIGHT.SQUARE,
    multiSelect: true,
    permissionPredicate: feedbackRequired,
};

const EDIT_DRAWING: ToolbarItemConfig = {
    id: 'EDIT_DRAWING',
    name: 'Edit drawing',
    component: EditDrawingTool,
    height: TOOL_HEIGHT.SQUARE,
    multiSelect: false,
};

const TABLE_OPERATIONS: ToolbarItemConfig = {
    id: 'TABLE_OPERATIONS',
    name: null,
    component: TableOperationsToolList,
    height: TOOL_HEIGHT.SQUARE,
    multiSelect: false,
};

const ALIGNMENT: ToolbarItemConfig = {
    id: 'ALIGNMENT',
    name: 'Alignment',
    component: AlignmentTool,
    height: TOOL_HEIGHT.SQUARE,
    multiSelect: true,
    availabilityPredicate: (selectedElements) =>
        selectedElements.size > 1 && allSelectedElementsOnCanvas(selectedElements),
};

const DISTRIBUTE: ToolbarItemConfig = {
    id: 'DISTRIBUTE',
    name: 'Distribute',
    component: DistributeTool,
    height: TOOL_HEIGHT.SQUARE,
    multiSelect: true,
    availabilityPredicate: (selectedElements) =>
        selectedElements.size > 2 && allSelectedElementsOnCanvas(selectedElements),
};

const CONNECT_WITH_LINES: ToolbarItemConfig = {
    id: 'CONNECT_WITH_LINES',
    name: 'Connect',
    component: ConnectTool,
    height: TOOL_HEIGHT.SQUARE,
    multiSelect: true,
    availabilityPredicate: (selectedElements) =>
        selectedElements.size > 1 && allSelectedElementsOnCanvas(selectedElements),
};

export default {
    COLOR,
    TITLE,
    CAPTION,
    REACTION,
    ICON,
    MEDIA,
    MEDIA_LOOP,
    MEDIA_AUTOPLAY,
    DISPLAY_MODE,
    IMAGE_EDIT,
    SHOW_BACKGROUND,
    CUSTOM_COLOR,
    COLOR_DISPLAY,
    START_ARROW,
    END_ARROW,
    LINE_STYLE,
    LINE_WEIGHT,
    LINE_LABEL,
    COLLAPSE,
    EDIT_DRAWING,
    TABLE_OPERATIONS,
    ALIGNMENT,
    DISTRIBUTE,
    CONNECT_WITH_LINES,
} as const;
